import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setEnergyReport = (state, { energyReport }) => {
  return state.merge({ energyReport });
};

const setEnergyReportFilters = (state, { energyReportFilters }) => {
  return state.merge({ energyReportFilters });
};

const setFactoryReport = (state, { factoryReport }) => {
  return state.merge({ factoryReport });
};

const setFactoryOeeReport = (state, { factoryOeeReport }) => {
  return state.merge({ factoryOeeReport });
};

const setFactoryAvailabilityReport = (state, { factoryAvailabilityReport }) => {
  return state.merge({ factoryAvailabilityReport });
};

const setFactoryPerformanceReport = (state, { factoryPerformanceReport }) => {
  return state.merge({ factoryPerformanceReport });
};

const setFactoryQualityReport = (state, { factoryQualityReport }) => {
  return state.merge({ factoryQualityReport });
};

const setFactoryReportFilters = (state, { factoryReportFilters }) => {
  return state.merge({ factoryReportFilters });
};
const setFactoryDetailReport = (state, { factoryDetailReport }) => {
  return state.merge({ factoryDetailReport });
};

const setFactoryDayReport = (state, { factoryDayReport }) => {
  return state.merge({ factoryDayReport });
};

const setShiftReport = (state, { shiftReport }) => {
  return state.merge({ shiftReport });
};

const setEquipmentDowntimes = (state, { equipmentDowntimes }) => {
  return state.merge({ equipmentDowntimes });
};

const setEquipmentEfficiencyReport = (state, { equipmentEfficiencyReport }) => {
  return state.merge({ equipmentEfficiencyReport });
};

const setEquipmentReportFilters = (state, { equipmentReportFilters }) => {
  return state.merge({ equipmentReportFilters });
};
const setEquipmentOeeReport = (state, { equipmentOeeReport }) => {
  return state.merge({ equipmentOeeReport });
};

const setEquipmentAvailabilityReport = (state, { equipmentAvailabilityReport }) => {
  return state.merge({ equipmentAvailabilityReport });
};

const setEquipmentPerformanceReport = (state, { equipmentPerformanceReport }) => {
  return state.merge({ equipmentPerformanceReport });
};

const setEquipmentQualityReport = (state, { equipmentQualityReport }) => {
  return state.merge({ equipmentQualityReport });
};

const setProductEfficiencyReport = (state, { productEfficiencyReport }) => {
  return state.merge({ productEfficiencyReport });
};

const setRejectionReport = (state, { rejectionReport }) => {
  return state.merge({ rejectionReport });
};

const setDowntimeReport = (state, { downtimeReport }) => {
  return state.merge({ downtimeReport });
};

const setRejectionReportFilters = (state, { rejectionReportFilters }) => {
  return state.merge({ rejectionReportFilters });
};

const setCustomDowntimeReportFilters = (state, { customDowntimeReportFilters }) => {
  return state.merge({ customDowntimeReportFilters });
};

const setCustomJobReport = (state, { customJobReport }) => {
  return state.merge({ customJobReport });
};

const setDowntimeAnalysisReport = (state, { downtimeAnalysisReport }) => {
  return state.merge({ downtimeAnalysisReport });
};

const setDowntimeReportFilters = (state, { downtimeReportFilters }) => {
  return state.merge({ downtimeReportFilters });
};

const setToolAnalysisReport = (state, { toolAnalysisReport }) => {
  return state.merge({ toolAnalysisReport });
};

const setJobReport = (state, { jobReport }) => {
  return state.merge({ jobReport });
};

const setJobReportFilters = (state, { jobReportFilters }) => {
  return state.merge({ jobReportFilters });
};

const setShiftReportFilters = (state, { shiftReportFilters }) => {
  return state.merge({ shiftReportFilters });
};

const setUnitTypeByFactory = (state, { factoryUnits }) => {
  return state.merge({ factoryUnits });
};

const setEquipmentsByGroup = (state, { groupEquipments }) => {
  return state.merge({ groupEquipments });
};
const setLinesByGroup = (state, { groupLines }) => {
  return state.merge({ groupLines });
};
const setPowerBiEmbedData = (state, { powerBiApiEmbedData }) => {
  return state.merge({ powerBiApiEmbedData });
};
const setFactorySummaryReport = (state, { factorySummaryReportData }) => {
  return state.merge({ factorySummaryReportData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_FACTORY_REPORT,
    actionFunction: setFactoryReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_OEE_REPORT,
    actionFunction: setFactoryOeeReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_AVAILABILITY_REPORT,
    actionFunction: setFactoryAvailabilityReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_PERFORMANCE_REPORT,
    actionFunction: setFactoryPerformanceReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_QUALITY_REPORT,
    actionFunction: setFactoryQualityReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_REPORT_FILTERS,
    actionFunction: setFactoryReportFilters,
  },
  {
    actionType: ActionTypes.SET_FACTORY_DETAIL_REPORT,
    actionFunction: setFactoryDetailReport,
  },
  {
    actionType: ActionTypes.SET_FACTORY_DAY_REPORT,
    actionFunction: setFactoryDayReport,
  },
  {
    actionType: ActionTypes.SET_ENERGY_REPORT,
    actionFunction: setEnergyReport,
  },
  {
    actionType: ActionTypes.SET_ENERGY_REPORT_FILTERS,
    actionFunction: setEnergyReportFilters,
  },
  {
    actionType: ActionTypes.SET_SHIFT_REPORT,
    actionFunction: setShiftReport,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_DOWNTIMES,
    actionFunction: setEquipmentDowntimes,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_EFFICIENCY_REPORT,
    actionFunction: setEquipmentEfficiencyReport,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_REPORT_FILTERS,
    actionFunction: setEquipmentReportFilters,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_OEE_REPORT,
    actionFunction: setEquipmentOeeReport,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_AVAILABILITY_REPORT,
    actionFunction: setEquipmentAvailabilityReport,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_PERFORMANCE_REPORT,
    actionFunction: setEquipmentPerformanceReport,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_QUALITY_REPORT,
    actionFunction: setEquipmentQualityReport,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_EFFICIENCY_REPORT,
    actionFunction: setProductEfficiencyReport,
  },
  {
    actionType: ActionTypes.SET_REJECTION_REPORT,
    actionFunction: setRejectionReport,
  },
  {
    actionType: ActionTypes.SET_DOWNTIME_REPORT,
    actionFunction: setDowntimeReport,
  },
  {
    actionType: ActionTypes.SET_REJECTION_REPORT_FILTERS,
    actionFunction: setRejectionReportFilters,
  },
  {
    actionType: ActionTypes.SET_CUSTOM_DOWNTIME_REPORT_FILTERS,
    actionFunction: setCustomDowntimeReportFilters,
  },
  {
    actionType: ActionTypes.SET_DOWNTIME_ANALYSIS_REPORT,
    actionFunction: setDowntimeAnalysisReport,
  },
  {
    actionType: ActionTypes.SET_DOWNITME_REPORT_FILTERS,
    actionFunction: setDowntimeReportFilters,
  },
  {
    actionType: ActionTypes.SET_TOOL_ANALYSIS_REPORT,
    actionFunction: setToolAnalysisReport,
  },
  {
    actionType: ActionTypes.SET_JOB_REPORT,
    actionFunction: setJobReport,
  },
  {
    actionType: ActionTypes.SET_CUSTOM_JOB_REPORT,
    actionFunction: setCustomJobReport,
  },
  {
    actionType: ActionTypes.SET_JOB_REPORT_FILTERS,
    actionFunction: setJobReportFilters,
  },
  {
    actionType: ActionTypes.SET_SHIFT_REPORT_FILTERS,
    actionFunction: setShiftReportFilters,
  },
  {
    actionType: ActionTypes.SET_UNIT_TYPE_BY_FACTORY,
    actionFunction: setUnitTypeByFactory,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENTS_BY_GROUP,
    actionFunction: setEquipmentsByGroup,
  },
  {
    actionType: ActionTypes.SET_LINES_BY_GROUP,
    actionFunction: setLinesByGroup,
  },
  {
    actionType: ActionTypes.SET_POWER_BI_TOKEN,
    actionFunction: setPowerBiEmbedData,
  },
  {
    actionType: ActionTypes.SET_FACTORY_SUMMARY_REPORT,
    actionFunction: setFactorySummaryReport,
  },
];
